






























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {mdiPlus} from '@mdi/js';

@Component
export default class NewButton extends Vue {
  @Prop({default: 'primary'}) private color!: string;
  @Prop({default: false}) private loading!: boolean;
  @Prop({default: false}) private horizontal!: boolean;
  @Prop({default: ''}) private label!: string;
  private iconAdd = mdiPlus;
}
